/** @format */
import { css } from 'styled-components';

import { StyledMarketConfirmationModalProps } from './types';

const baseStyles = ({
    $showTranslations,
}: StyledMarketConfirmationModalProps) => css`
    .heading {
        margin-bottom: var(--layout-spacing-8);
    }

    .heading-translation {
        text-align: center;
        margin-bottom: var(--layout-spacing-24);
    }

    .markets {
        list-style: none;
        padding: 0;
    }

    .markets-divider {
        text-align: center;
        margin-bottom: var(--layout-spacing-8);
    }

    ${!$showTranslations &&
    css`
        .heading {
            margin-bottom: var(--layout-spacing-32);
        }
    `}
`;

export const styles = (props: StyledMarketConfirmationModalProps) => css`
    ${baseStyles(props)}
`;
